import { useFormik } from "formik";
import * as yup from "yup";
import { ProfileLineItem, ProfileStatus } from "@interfaces/profile";
import { FormControlLabel, FormGroup, Switch, Grid, Box } from "@mui/material";
import { StyledTextField } from "@stories/atoms/StyledTextField/StyledTextField";
import { StyledButton } from "@stories/atoms/StyledButton/StyledButton";

interface ProfileFormProps {
  profile: ProfileLineItem;
  handleSubmit: (profile: ProfileLineItem) => void;
}

export const ProfileForm = ({ profile, handleSubmit }: ProfileFormProps) => {
  const validationSchema = yup.object({
    name: yup.string().required("Nname is required"),
    emailNotifications: yup.boolean().required("Email notifications required"),
  });
  const formik = useFormik({
    initialValues: {
      name: profile.name,
      emailNotifications: profile.emailNotifications,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleSubmit({
        ...profile,
        name: values.name,
        emailNotifications: values.emailNotifications,
        status: ProfileStatus.Active,
      });
    },
  });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <StyledTextField
              id="name"
              name="name"
              label="Name"
              fullWidth
              margin="dense"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name ? formik.errors.name : ""}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    defaultChecked
                    value={formik.values.emailNotifications}
                    onChange={(event, checked) => {
                      formik.setFieldValue("emailNotifications", checked);
                    }}
                  />
                }
                label="Email Notifications"
              />
            </FormGroup>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              display: "flex !important",
              justifyContent: "right !important;",
            }}
          >
            <StyledButton variant="contained" type="submit">
              Save
            </StyledButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};
